
import { Row, Col, Checkbox, Button } from 'antd'
import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import '../confirmDialog.css'
import './CompareDialog.css'
import { isIPSAdministrator } from 'utils/UserInfo'

function MatchProjectsDialog({ show, handleCancel, duplicateProjects, handleDelete, onSelectProject, onEditClick, onAccept }) {

    const [selectedProject, setSelectedProject] = useState(null)
    const [checkedIndex, setCheckedIndex] = useState("")
    const edwProject = duplicateProjects && duplicateProjects[0];

    const handleChangeCheck = (project, index) => {

        if (checkedIndex === index) {
            setCheckedIndex(0)
            setSelectedProject(null)
            onSelectProject(null)
        } else {
            setCheckedIndex(index)
            setSelectedProject(project)
            onSelectProject(project)
        }
    }

    useEffect(() => { 
    
      return () => {
        setCheckedIndex("")
        setSelectedProject(null)
      }
    }, [duplicateProjects])
    
    return (
        <>
            <Modal className='centered-title-modal' show={show} onHide={handleCancel} centered style={{ fontSize: 12 }} >

                <Modal.Header closeButton style={{ fontSize: 16 }}>
                    A duplicate record(s) with the same BPID has been found. Please review the data below for accuracy.
                </Modal.Header>

                <div>
                    <Row> <Col span={24}><div className='head-txt heading-title'>Data From EDW</div></Col></Row>
                    {edwProject &&

                        <Row>
                            <Col span={24} className='space-btm'>

                                <div className='' >
                                    <Row>
                                        <Col span={12}>Station Name:</Col>
                                        <Col span={12}>{edwProject.ecosysStation}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>Project Description:</Col>
                                        <Col span={12}>{edwProject.projectDescription}</Col>
                                    </Row>
                                </div>
                                <div className='spacing-section'>
                                    <Row>
                                        <Col span={12}>BPID:</Col>
                                        <Col span={12}>{edwProject.bpid}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>MPID:</Col>
                                        <Col span={12}>{edwProject.mpid}</Col>
                                    </Row>
                                </div>
                                <div className='spacing-section' >
                                    <Row>
                                        <Col span={12}>Construction Start Date:</Col>
                                        <Col span={12}>{edwProject.constructionStartDate}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>In-Service Date:</Col>
                                        <Col span={12}>{edwProject.inServiceDate}</Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    }
                    {duplicateProjects && duplicateProjects.filter(project=> project.duplicate || project.tclSyncFlag==='N').length > 0 &&
                        <>
                            <Row><Col span={24}> <div className='head-txt heading-title'>Manually Entered Data</div></Col></Row>
                            <Row>
                                <Col span={24} className="space-btm styled-scrollbars">

                                    {duplicateProjects.filter(project=> project.duplicate || project.tclSyncFlag==='N' ).map((newProject, index) => (
                                        <Row className='spacing-section bordered-bottom' key={newProject.bpid + index} >
                                            <Col span={2}>
                                                <Checkbox checked={selectedProject && (newProject.tclProjectId + '_#' + (index + 1) === checkedIndex)} onChange={() => handleChangeCheck(newProject, newProject.tclProjectId + '_#' + (index + 1))} />
                                            </Col>
                                            <Col span={22}>
                                                <div>
                                                    <Row>
                                                        <Col span={12}>Station Name:</Col>
                                                        <Col span={12}>{newProject.stationName}</Col>
                                                    </Row>
                                                    {/* <Row>
                                                        <Col span={12}>Station Description:</Col>
                                                        <Col span={12}>{newProject.projectDescription}</Col>
                                                    </Row> */}
                                                </div>
                                                <div className='spacing-section'>
                                                    <Row>
                                                        <Col span={12}>BPID:</Col>
                                                        <Col span={12}>{newProject.bpid}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={12}>Work Order:</Col>
                                                        <Col span={12}>{newProject.workOrder}</Col>
                                                    </Row>
                                                </div>
                                                {/* <div className='spacing-section'>
                                                    <Row>
                                                        <Col span={12}>Construction Start Date:</Col>
                                                        <Col span={12}>{newProject.constructionStartDate}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={12}>In-Service Date:</Col>
                                                        <Col span={12}>{newProject.inServiceDate}</Col>
                                                    </Row>
                                                </div> */}
                                            </Col>
                                        </Row>))}
                                </Col>
                            </Row>
                        </>
                    }
                </div>


                <div className="footer-centered-content" >
                    {duplicateProjects && (duplicateProjects.length === 1) &&
                        <Button type='primary' disabled={!selectedProject && !checkedIndex} onClick={onAccept}>Accept</Button>
                    }
                    
                    <Button type='primary' disabled={!selectedProject && !checkedIndex} onClick={onEditClick} >Edit </Button>
                    {/* https://jira.aepsc.com/browse/TCHEK-629 */}
                    
                    <Button type='primary' disabled={!selectedProject && !checkedIndex}  onClick={handleDelete}>Delete</Button>
                </div>
            </Modal>
        </>
    )
}

export default MatchProjectsDialog            